angular.module('bookAndPay').directive('stripeForm', function() {
  return {
    restrict: 'EA',
    template: require('templates/book_and_pay/stripe_form.html.slim'),
    scope: {
      cart: '=',
      months: '=',
      years: '=',
      currency: '=',
      expired: '=',
      toNewCart: '&',
      setLoading: '&',
      onUnavailable: '&'
    },
    controller: ["$scope", "$state", "$http", "$timeout", "DataService", "CreditCardValidationService", function($scope, $state, $http, $timeout, DataService, CreditCardValidationService) {
      var getPaymentMethodReference, initStripe, stripeResponseHandler, submitPaymentMethod;
      $scope.data = DataService;
      $scope.creditCard = {};
      initStripe = function() {
        var elements, onCardChange, style;
        $scope.stripe = Stripe($scope.cart.realtime_public_key);
        elements = $scope.stripe.elements();
        style = {
          base: {
            fontFamily: 'Helvetica',
            fontSize: '18px',
            fontWeight: 400,
            '::placeholder': {
              color: '#828282'
            }
          },
          invalid: {
            color: '#fa755a',
            iconColor: '#fa755a'
          }
        };
        $scope.cardElement = elements.create('card', {
          style: style,
          disabled: $scope.expired
        });
        $scope.$watch('expired', function(expired) {
          var ref;
          if (expired && ((ref = $scope.cardElement) != null ? ref.update : void 0)) {
            return $scope.cardElement.update({
              disabled: expired
            });
          }
        });
        $timeout(function() {
          return $scope.cardElement.mount('#card-element');
        });
        onCardChange = function() {
          return $scope.cardElement.on('change', function(event) {
            return $timeout(function() {
              var displayErrorEl;
              $scope.cardReady = event.complete;
              displayErrorEl = document.getElementById('card-errors');
              if (displayErrorEl != null) {
                if (event.error) {
                  return displayErrorEl.textContent = event.error.message;
                } else {
                  return displayErrorEl.textContent = '';
                }
              }
            });
          });
        };
        return onCardChange();
      };
      if (window.Stripe) {
        initStripe();
      } else {
        $scope.stripeUnavailable = true;
        $scope.onUnavailable();
      }
      $scope.cardReady = false;
      submitPaymentMethod = function(options) {
        return $scope.stripe.confirmCardPayment($scope.cart.realtime_token, {
          payment_method: {
            card: $scope.cardElement,
            billing_details: options.billing_details
          }
        });
      };
      getPaymentMethodReference = function() {
        var options;
        options = {
          billing_details: {
            name: $scope.creditCard.name
          }
        };
        return submitPaymentMethod(options).then(function(confirmResult) {
          return $timeout(function() {
            var intent;
            if (confirmResult.error) {
              if (window.Rollbar) {
                window.Rollbar.error('Book and pay card authentication error', {
                  message: confirmResult.error.message,
                  code: confirmResult.error.code
                });
              }
              $scope.errorMessage = 'We are unable to authenticate your payment method. Please try again.';
              $scope.isLoading = false;
              return $scope.setLoading({
                loading: false
              });
            } else {
              intent = confirmResult.paymentIntent;
              return $scope.stripe.createPaymentMethod('card', $scope.cardElement, options).then(function(createPaymentMethodResponse) {
                return $timeout(function() {
                  if (createPaymentMethodResponse != null ? createPaymentMethodResponse.error : void 0) {
                    if (window.Rollbar) {
                      window.Rollbar.error('Book and pay createPaymentMethod error', createPaymentMethodResponse.error);
                    }
                    $scope.errorMessage = 'We were unable to read your card details. Please try again.';
                    $scope.isLoading = false;
                    return $scope.setLoading({
                      loading: false
                    });
                  } else {
                    return stripeResponseHandler(intent.payment_method, createPaymentMethodResponse.paymentMethod);
                  }
                });
              });
            }
          });
        });
      };
      $scope.formReady = function() {
        var ref;
        return ((ref = $scope.creditCard.name) != null ? ref.length : void 0) && $scope.cardReady && !$scope.isLoading && $scope.creditCard.termsAccepted;
      };
      $scope.onSubmit = function() {
        if (!$scope.formReady()) {
          return;
        }
        $scope.setLoading({
          loading: true
        });
        $scope.isLoading = true;
        $scope.errorMessage = '';
        return getPaymentMethodReference();
      };
      $scope.reload = function() {
        return window.location.reload();
      };
      return stripeResponseHandler = function(token, paymentMethodReference) {
        var params, url;
        params = {
          cart: {
            payment_method_reference: token,
            cardholder_name: paymentMethodReference.billing_details.name,
            card_brand: paymentMethodReference.card.brand,
            card_number: paymentMethodReference.card.last4,
            card_expiry_month: paymentMethodReference.card.exp_month,
            card_expiry_year: paymentMethodReference.card.exp_year,
            payment_success: true
          }
        };
        url = `/websites/${window.DATA.domain}/book_and_pay/carts/${$scope.cart.cart_uuid}/handle_payment_result`;
        return $http.put(url, params).then(function(response) {
          $scope.setLoading({
            loading: false
          });
          return $state.go('bookAndPay.complete', {
            uuid: $scope.cart.cart_uuid
          });
        }, function(response) {
          if (window.Rollbar) {
            window.Rollbar.error('Book and pay handle_payment_result error', response.data);
          }
          $scope.isLoading = false;
          $scope.setLoading({
            loading: false
          });
          return $scope.errorMessage = 'An unexpected error occurred. Please try again later.';
        });
      };
    }]
  };
});
